import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
  }
}
